import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MultiFileImportFlow } from './MultiFileImportFlow';

interface ImportFilesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * The single import-modal surface. Upload is the treasurer's most frequent
 * action, so it now opens from three places — the Sources page, the finance
 * masthead, and the Close inbox strip — and all three mount THIS component so
 * the modal markup and copy can never drift apart. Account/connection
 * management stays on the Sources page; only the act of uploading travels.
 *
 * Controlled (open/onOpenChange) rather than self-stating so each trigger keeps
 * ownership of its own open flag. The Radix Dialog leaves the body unmounted
 * while closed, so MultiFileImportFlow (and its react-query usage) only runs
 * once the dialog is actually open.
 */
export function ImportFilesDialog({ open, onOpenChange }: ImportFilesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* Wider than the shadcn default so the import preview — the already-filed
          skip list (date · amount · donor) and the "…so you don't double-report"
          heads-up — has room to breathe instead of clipping. `[&>*]:min-w-0` lets
          the grid children shrink (shadcn DialogContent is a grid; grid items
          default to min-width:auto and would otherwise force horizontal overflow). */}
      {/* Its own explicit "Done" close (hideClose) instead of the bare ✕ — an
          import is a task the treasurer finishes, so a labelled action reads
          clearer than a corner glyph. Esc / click-outside still dismiss. */}
      <DialogContent
        hideClose
        className="max-h-[90vh] max-w-3xl overflow-y-auto [&>*]:min-w-0"
      >
        <DialogHeader>
          <DialogTitle>Add files</DialogTitle>
        </DialogHeader>
        <MultiFileImportFlow />
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            Done
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
